import script from "./NextflowTask.vue?vue&type=script&lang=ts&setup=true"
export * from "./NextflowTask.vue?vue&type=script&lang=ts&setup=true"

import "./NextflowTask.vue?vue&type=style&index=0&id=e6b57586&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6b57586"]])

export default __exports__